class EntranceExit {
    constructor(object, domElements) {
        this._object = object;
        this._domElements = domElements;
        this._extraElements = [];
        this.playTimeStamp = 0;
        this.pausedTimeStamp = 0;
        this.timePlayed = 0;
        this.current = "animation";
        this._animationTimeout = null;
        this._timeoutPointerEvents = null
    }

    get domElements() {
        return this._domElements.filter(el => el);
    }

    init(options = {}) {
        const object = this._object;

        object.animation = options.animation && options.animation.name
            ? options.animation
            : { name: "none", duration: 0, delay: 0 };

        object.leavingAnimation = options.leavingAnimation && options.leavingAnimation.name
            ? options.leavingAnimation
            : { name: "none", duration: 0, delay: 0 };

        object.split = options.split || false;
        object.splitAnimation = object.split && options.splitAnimation && options.splitAnimation.name
            ? options.splitAnimation
            : { name: "none", duration: 0, delay: 0 };

        object.parentLayer.leavingAnimationDelay = Math.max((object.parentLayer.leavingAnimationDelay || 0), object.leavingAnimation.delay + object.leavingAnimation.duration);
        object.parentLayer.animationDelay = Math.max((object.parentLayer.animationDelay || 0), object.animation.delay + object.animation.duration);


        if (!Q3.editMode) {
            this.setExtraElements();
        }

        if (this._animationTimeout) {
            clearTimeout(this._animationTimeout);

            this._animationTimeout = null;
        }

        if (!Q3.editMode && this.totalTime) this.play();
    }

    setExtraElements() {
        const object = this._object;
        let extraElements = [];
        if (object.split === "lines" || object.split === "words") {
            extraElements = object.splitTextboxBy(object.split);
        }
        if (object.split === "paragraphs") {
            extraElements = object.getParagraphs();
        }
        this._extraElements = extraElements;
    }

    playLeave() { }

    cancelLeave() {
        if (this._animationTimeout) {
            clearTimeout(this._animationTimeout);

            this._animationTimeout = null;
        }

        this._setAnimationToEntrance();
    }

    previewSplitAnimation(splitAnimation = this._object.splitAnimation) {
        const object = this._object;
        let extraElements = [];
        let animation = object.split && splitAnimation && splitAnimation.name
            ? splitAnimation
            : { name: "none", duration: 1, delay: 0 };
        animation.delay = 0;
        if (object.split === "lines" || object.split === "words") {
            extraElements = object.splitTextboxBy(object.split);
        }
        if (object.split === "paragraphs") {
            extraElements = object.getParagraphs();
        }
        let delay = animation.delay;
        for (let domElement of extraElements) {
            domElement.classList.add("animated");
            domElement.style.animationPlayState = "running";
            domElement.style.animationName = animation.name;
            domElement.style.animationDuration = animation.duration/extraElements.length*4 + "s";
            domElement.style.animationDelay = delay + "s";
            delay += object.splitAnimation.duration/extraElements.length;
        }
    }

    _setAnimationToEntrance() {
        const object = this._object;

        for (let domElement of this.domElements) {
            domElement.classList.add("animated");
            domElement.style.animationPlayState = "running";
            domElement.style.animationName = object.animation.name;
            domElement.style.animationDuration = object.animation.duration + "s";
            domElement.style.animationDelay = object.animation.delay + "s";
            domElement.style.pointerEvents = 'none';
        }

        let delay = object.animation.delay + Math.max(object.animation.duration-0.5, 0) + object.splitAnimation.delay;
        for (let domElement of this._extraElements) {
            domElement.classList.add("animated");
            domElement.style.animationPlayState = "running";
            domElement.style.animationName = object.splitAnimation.name;
            domElement.style.animationDuration = object.splitAnimation.duration / this._extraElements.length * 4 + "s";
            domElement.style.animationDelay = delay + "s";
            delay += object.splitAnimation.duration / this._extraElements.length;
        }

        this.updateTimeout();
    }

    _setAnimationToExit() {
        const object = this._object;

        for (let domElement of this.domElements) {
            const enterDuration = object.animation.name !== "none" ? object.animation.duration : 0;
            domElement.classList.add("animated");
            domElement.style.animationName = object.leavingAnimation.name;
            domElement.style.animationDuration = object.leavingAnimation.duration + "s";
            domElement.style.animationDelay = (object.leavingAnimation.delay - enterDuration) + "s";
            if (this._object.type2d === "Video") domElement.style.animationDelay = 0;
        }

        this.timePlayed = this.enterTime;
        this.playTimeStamp = new Date();
        this.pausedTimeStamp = 0;

        this.updateTimeout();
    }

    _removePointerEvents(delay) {
        clearTimeout(this._timeoutPointerEvents)
        this._timeoutPointerEvents = setTimeout(() => {
            for (let domElement of this.domElements) {
                domElement.style.removeProperty('pointer-events')
            }
        }, delay)
    }

    _clearAnimation() {
        this.isPaused = false;

        for (let domElement of this.domElements) {
            domElement.classList.remove("animated");
            domElement.style.removeProperty('animation-play-state');
            domElement.style.removeProperty('animation-name');
            domElement.style.removeProperty('animation-duration');
            domElement.style.removeProperty('animation-delay');
            domElement.style.removeProperty('pointer-events')
        }
    }

    stop() {
        this.reset();
        if (Q3.editMode) {
            if (this.leavingTime)
                this._object.parentLayer.domElement.classList.add("finished-animation");
        } else {
            if (this._object.onAnimationFinish) this._object.onAnimationFinish();
            else this._object.parentLayer.domElement.style.display = "none";
        }
        if (this._extraElements.length) {
            this._object.redraw();
        }
    }

    reset() {
        this._clearAnimation();

        clearTimeout(this._animationTimeout);

        this.timePlayed = 0;
        this.playTimeStamp = 0;
        this.pausedTimeStamp = 0;
    }

    play() {
        if (this.isPaused) this.resume();
        else this.restart();
    }

    pause() {
        this.isPaused = true;
        this.pausedTimeStamp = new Date().getTime();
        this.timePlayed = this.timePlayed + this.pausedTimeStamp - this.playTimeStamp;

        clearTimeout(this._animationTimeout);
        clearTimeout(this._timeoutPointerEvents);

        for (let domElement of [...this.domElements, ...this._extraElements]) {
            domElement.style.animationPlayState = "paused";
        }
    }

    resume() {
        this.isPaused = false;
        this.playTimeStamp = new Date().getTime();

        this.updateTimeout();

        for (let domElement of this.domElements) {
            domElement.style.animationPlayState = "running";
        }
    }

    updateTimeout() {
        clearTimeout(this._animationTimeout);
        clearTimeout(this._timeoutPointerEvents);

        if (!this.leavingTime || this._object.type2d === "Video")  {
            this._removePointerEvents(this.enterTime - this.timePlayed)
            return
        };

        if (this.timePlayed < this.enterTime) {
            this._removePointerEvents(this.enterTime - this.timePlayed)
            this._animationTimeout = setTimeout(() => {
                this._setAnimationToExit();
            }, this.enterTime - this.timePlayed);
        } else {
            this._animationTimeout = setTimeout(() => {
                this.stop();
            }, this.leavingTime - (this.timePlayed - this.enterTime));
        }
    }

    restart() {
        this.reset();
        this.playTimeStamp = new Date().getTime();

        if (this.enterTime || this.leavingTime) this._setAnimationToEntrance();
        // else this._setAnimationToExit();
    }

    get enterTime() {
        return (this._object.animation.name !== "none"
            ? (this._object.animation.duration + this._object.animation.delay) * 1000
            : 0) + (this._object.splitAnimation.name !== "none"
            ? (this._object.splitAnimation.duration + this._object.splitAnimation.delay) * 1000
            : 0)
    }

    get leavingTime() {
        return this._object.leavingAnimation.name !== "none"
            ? (this._object.leavingAnimation.duration + this._object.leavingAnimation.delay) * 1000
            : 0
    }

    get totalTime() { return this.enterTime + this.leavingTime; }
}

export default EntranceExit;
